import React from "react"

import BaseMessage from "@/components/ACExternalConversationPanel/MessageList/CommonMessage/BaseMessage"

import { Messages } from "@/components"
import { useActiveCampaignExternalChatGlobalStateStore } from "@/store/ActiveCampaignExternalChatGlobalState"

type CommonMessageProps = {
	messageId: string
}

const CommonMessage: React.FC<CommonMessageProps> = (props) => {
	const {
		messageId
	} = props

	const activeCampaignExternalChatGlobalState = useActiveCampaignExternalChatGlobalStateStore()
	const message = activeCampaignExternalChatGlobalState.message.getById(messageId)

	return (
		<BaseMessage
			message={message}
			messageContentBoxStyle={(
				Messages.getMessageContentBoxStyle(message.extraData)
			)}
			childContent={(
				Messages.getChildContent(message.type, {
					fileName: message.fileName,
					caption: message.caption,
					content: message.content,
					uploadingMedia: message.uploadingMedia,
					mediaUploadProgress: message.uploadProgressInPercentage,
					fancyBoxSlug: String(message.inboxChannelChatId),
					copySpecial: false,
					translateVariables: false,
					extraData: message.extraData,
					messageId: message.id,
					/**
					 * Today, message sending feature doesnt treat errors
					 * We only have generic errors then
					 * Because of that, we need to add a generic error into that property
					 */
					messageErrorCode: message.status === "not-sent" ? "error" : ""
				})
			)}
			childContentHeader={(
				Messages.getChildContentHeader({
					extraData: message.extraData,
					fileName: message.fileName,
					uploadingMedia: message.uploadingMedia,
					mediaUploadProgress: message.uploadProgressInPercentage,
					fancyBoxSlug: String(message.inboxChannelChatId),
					translateVariables: false,
					messageId: message.id,
					/**
					 * Today, message sending feature doesnt treat errors
					 * We only have generic errors then
					 * Because of that, we need to add a generic error into that property
					 */
					messageErrorCode: message.status === "not-sent" ? "error" : ""
				})
			)}
			childContentFooter={(
				Messages.getChildContentFooter(message.type, {
					extraData: message.extraData
				})
			)}
			childContainerFooter={(
				Messages.getChildContainerFooter({
					extraData: message.extraData,
					sentByCustomer: message.sentByCustomer,
					status: message.status
				})
			)}
		/>
	)
}

export default CommonMessage
